module.exports = __webpack_public_path__ + "static/img/jcg.2460687.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/itemImgs/jcg.jpg
// module id = oXbX
// module chunks = 0